import { ROLE_LABEL, type Role } from '@/data/types'

/**
 * fp_roleslists.role_name for the signed-in agent's hierarchy tier.
 * Company Master uses CM-UI; players have no Access Level staff catalog.
 */
export function staffFpRoleslistName(role: Role | undefined): string | null {
  if (!role || role === 'player') return null
  return ROLE_LABEL[role]
}
